/* Nordbjærg's cart panel (P3-05).
   The theme's own mini-cart code opens and closes the panel, traps focus and closes on Esc.
   This file adds two things:
   1. A click outside the open panel closes it (the dimmed page acts as a backdrop).
   2. One complementary add-on for the first item in the cart, from Shopify's recommendations
      (intent=complementary, limit=1). Nothing shows when Shopify has none. */
(function () {
  'use strict';

  var loadedFor = {};

  function miniCart() {
    return document.getElementById('mini-cart');
  }

  function isOpen(cart) {
    return cart && cart.getAttribute('aria-hidden') === 'false';
  }

  // 1. Click outside closes the panel
  document.addEventListener('click', function (event) {
    var cart = miniCart();
    if (!isOpen(cart)) return;
    if (cart.contains(event.target)) return;
    if (event.target.closest && event.target.closest('[data-action="toggle-mini-cart"]')) return;
    var toggle = document.querySelector('[aria-controls="mini-cart"][data-action="toggle-mini-cart"]');
    if (toggle) {
      event.preventDefault();
      toggle.click();
    }
  }, true);

  // 2. Add-on
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
    try {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' kr.';
    }
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderAddon(slot, product) {
    var variant = (product.variants || []).filter(function (v) { return v.available; })[0];
    if (!variant) return;
    var image = product.featured_image ? product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
    slot.innerHTML =
      '<p class="nb-cart-addon__title">Køb også</p>' +
      '<div class="nb-cart-addon__item">' +
        (image ? '<img class="nb-cart-addon__image" src="' + escapeHtml(image) + '" alt="" width="60" height="60" loading="lazy">' : '') +
        '<div class="nb-cart-addon__info">' +
          '<a class="nb-cart-addon__name" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
          '<span class="nb-cart-addon__price">' + formatMoney(variant.price) + '</span>' +
        '</div>' +
        '<button type="button" class="button button--small button--secondary nb-cart-addon__add" data-variant-id="' + variant.id + '" data-nb-event="nb_grid_add" data-context="cart-addon">Læg i kurv</button>' +
      '</div>';
    slot.hidden = false;
  }

  function fillAddon() {
    var cart = miniCart();
    if (!cart) return;
    var slot = cart.querySelector('[data-nb-cart-addon]');
    if (!slot || !slot.hidden) return;
    var productId = slot.getAttribute('data-product-id');
    if (!productId) return;

    var cached = loadedFor[productId];
    if (cached === null) return;
    if (cached) {
      renderAddon(slot, cached);
      return;
    }

    var base = (window.routes && window.routes.productRecommendationsUrl) || '/recommendations/products';
    fetch(base + '.json?product_id=' + encodeURIComponent(productId) + '&intent=complementary&limit=1', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : { products: [] }; })
      .then(function (data) {
        var product = data && data.products && data.products[0];
        loadedFor[productId] = product || null;
        if (product) renderAddon(slot, product);
      })
      .catch(function () { loadedFor[productId] = null; });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.nb-cart-addon__add');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    var addUrl = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(button.getAttribute('data-variant-id')), quantity: 1 })
    }).then(function (response) {
      button.disabled = false;
      if (!response.ok) return;
      // The theme re-renders the mini-cart on product:added
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { quantity: 1, productAdded: false }
      }));
    }).catch(function () { button.disabled = false; });
  });

  // The mini-cart is re-rendered after every change, so watch it and fill the slot again
  function watch() {
    var cart = miniCart();
    if (!cart) return;
    fillAddon();
    new MutationObserver(function () { fillAddon(); }).observe(cart, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
